

<!---- task link  ---->
<div *ngIf="taskState != 'Done' && taskType == 'link' " class="card mb-3">
    <div class="card-body">
        <div class="display-inline">
            <h2 class="display-inline f-20" style="font-weight: 500;">{{taskTitle}}</h2>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <a *ngIf="canEdit" (click)="completeTask()" target="_blank" href="{{linkurl}}"><button class="btn mt-2 btn-noround">
                <p class="mb-0 btn-text f-15" style="font-weight: 600;">{{linktext}}</p>
            </button></a>
    </div>
</div>
<!---- task link   ---->


<!---- task link completed state  ---->
<div *ngIf="taskState == 'Done' && taskType == 'link'" class="card mb-3">
    <div class="card-body">
        <div class="d-inline-flex">
            <span class="material-icons lh-30 align-middle" style="color:green;">
                task_alt
            </span>
            <h2 class="f-20 lh-30 align-middle pl-2 pr-2" style="font-weight: 500;">{{taskTitle}}</h2>
            <span class="badge badge-success mt-1" style="height:19px; ">{{ 'cpllist.completed' | trans }}</span>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <a *ngIf="canEdit" (click)="completeTask()" target="_blank" href="{{linkurl}}"><button class="btn mt-2 btn-noround">
                <p class="mb-0 btn-text f-15" style="font-weight: 600;">{{linktext}} <span
                        class="material-icons lh-25 align-middle">
                        done
                    </span></p>
            </button></a>
    </div>
</div>
<!---- task link completed state  end ---->

<!---- form task (Pending/Active) ---->
<div *ngIf="taskState != 'Done' && taskType == 'form'" class="card mb-3">
    <div class="card-body">
        <div class="display-inline">
            <h2 class="display-inline f-20" style="font-weight: 500;">{{taskTitle}}</h2>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <button *ngIf="canEdit" (click)="completeTask()" class="btn mt-2 btn-noround">
            <p class="btn-text mb-0 f-15" style="font-weight: 600;">{{ 'cpltask.completeform' | trans }}</p>
        </button>
    </div>
</div>
<!---- form task (Pending/Active) end ---->

<!---- form task (Completed) ---->
<div *ngIf="taskState == 'Done' && taskType == 'form'" class="card mb-3">
    <div class="card-body">
        <div class="d-inline-flex">
            <span class="material-icons lh-30 align-middle" style="color:green;">
                task_alt
            </span>
            <h2 class="f-20 lh-30 align-middle pl-2 pr-2" style="font-weight: 500;">{{taskTitle}}</h2>
            <span class="badge badge-success mt-1" style="height:19px; ">{{ 'cpllist.completed' | trans }}</span>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <button *ngIf="canEdit" (click)="completeTask()" class="btn mt-2 btn-noround">
            <p class="mb-0 btn-text f-15" style="font-weight: 600;">{{ 'cpltask.completeform' | trans }} <span
                    class="material-icons lh-25 align-middle">
                    done
                </span></p>
        </button>
    </div>
</div>
<!---- form task (Completed) end ---->

<!---- task  ---->
<div *ngIf="taskState != 'Done' && taskType == 'task'" class="card mb-3">
    <div class="card-body">
        <div class="display-inline">
            <h2 class="display-inline f-20" style="font-weight: 500;">{{taskTitle}}</h2>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <button *ngIf="canEdit" (click)="completeTask()" class="btn mt-2 btn-noround">
            <p class="btn-text mb-0 f-15" style="font-weight: 600;">{{ 'cpltask.completetask' | trans }}</p>
        </button>
    </div>
</div>
<!---- task  ---->
<!---- task overdue state example 
<div *ngIf="taskState != 'Done'" class="card mb-3 border-overdue">
    <div class="card-body">
        <div class="d-inline-flex">
            <span class="material-icons lh-30 align-middle" style="color:red;">
                whatshot
            </span>
            <h2 class="f-15 lh-30 align-middle pl-2 pr-2" style="font-weight: 500;">{{taskTitle}}</h2>
            <span class="badge badge-danger mt-1" style="height:19px; ">{{ 'cpllist.pending' | trans }}</span>
        </div>
        <quill-view-html class="quill-no-pad" [content]="taskDescription"></quill-view-html>
    </div>
</div>
task overdue state example end ---->

<!---- task completed state example ---->
<div *ngIf="taskState == 'Done' && taskType == 'task'" class="card mb-3">
    <div class="card-body">
        <div class="d-inline-flex">
            <span class="material-icons lh-30 align-middle" style="color:green;">
                task_alt
            </span>
            <h2 class="f-20 lh-30 align-middle pl-2 pr-2" style="font-weight: 500;">{{taskTitle}}</h2>
            <span class="badge badge-success mt-1" style="height:19px; ">{{ 'cpllist.completed' | trans }}</span>
        </div>
        <quill-view-html class="quill-no-pad f-15" [content]="taskDescription"></quill-view-html>
        <button *ngIf="canEdit" (click)="completeTask()" class="btn mt-2 btn-noround">
            <p class="mb-0 btn-text f-15" style="font-weight: 600;">{{ 'cpltask.completetask' | trans }} <span
                    class="material-icons lh-25 align-middle">
                    done
                </span></p>
        </button>
    </div>
</div>
<!---- task completed state  end ---->